import React from "react";
import Modal from "antd/lib/modal";
import Row from "antd/lib/row";
import Col from "antd/lib/col";
import CheckBox from "antd/lib/checkbox";
import Radio from "antd/lib/radio";
import InputNumber from "antd/lib/input-number";

class ReconcileAdvanceModal extends React.Component {

  constructor(props) {
    super(props);
    this.inputRef = React.createRef();
  }

  handleClick = () => {
    console.log("e");
    console.log(this.inputRef.current.focus(),"this.inputRef.current");
    console.log(this.inputRef,"this.inputRef.current.focus()1");
    this.inputRef.current.focus();

  }

  render() {
    const props = this.props;
    
    return (
      <Modal
        title="Advanced Reconciliation"
        okText="Reconcile"
        width="45%"
        visible={props.showModalPrompt}
        onOk={props.compareSales}
        okButtonProps={{ type: "successR" }}
        style={{backgroundColor : "#CEDDE5 !important;"}}
        onCancel={props.handleCancelPrompt}
        cancelButtonProps={{style:{ background: 'linear-gradient(180deg, #FFFFFF 0%, #F0F0F0 100%)'}}}
      >
        <div>
          <Row>
            <style>
              {`
        .ant-checkbox-group-item {
          display:block;
        }
        .ant-checkbox-wrapper + .ant-checkbox-wrapper {
            margin:0;
        }
      `}
            </style>
            <div style={{ marginTop: "6px" }}>
              <Col span={12}>
                <div>
                  <p style={{ textAlign: "left" }}>
                    <b>B2B</b>
                  </p>
                 
                  <CheckBox
                    indeterminate={props.indeterminate_b2b}
                    onChange={props.onCheckAllChange_b2b}
                    checked={props.checkAll_b2b}
                  >
                    Select all
                  </CheckBox>
                  <CheckBox.Group
                    options={props.plainOptions_b2b}
                    value={props.checkedList_b2b}
                    onChange={props.onChangeCB_b2b}
                    style={{display: "grid", color:'#298AB7'}}
                  >
                    <CheckBox value="Invoice Date">Invoice Date</CheckBox>
                    <CheckBox value="Invoice Value">Invoice Value</CheckBox>
                    <CheckBox value="Taxable Value">Taxable Value</CheckBox>
                    <CheckBox value="Taxes (IGST, CGST, SGST, CESS)">
                      Taxes (IGST, CGST, SGST, CESS)
                    </CheckBox>
                  </CheckBox.Group>
                </div>
              </Col>
              <Col span={12}>
                <div >
                  <p style={{ textAlign: "left" }}>
                    <b>CDNR</b>
                  </p>
                  
                  <CheckBox
                    indeterminate={props.indeterminate_cdnr}
                    onChange={props.onCheckAllChange_cdnr}
                    checked={props.checkAll_cdnr}
                  >
                    Select all
                  </CheckBox>
                  <CheckBox.Group
                    options={props.plainOptions_cdnr}
                    value={props.checkedList_cdnr}
                    onChange={props.onChangeCB_cdnr}
                    style={{display: "grid"}}
                  >
                    <CheckBox value="CDNR Value">CDNR Value</CheckBox>
                    <CheckBox value="CDNR Date">CDNR Date</CheckBox>
                    <CheckBox value="Taxable Value">Taxable Value</CheckBox>
                    <CheckBox value="Taxes (IGST, CGST, SGST, CESS)">
                      Taxes (IGST, CGST, SGST, CESS)
                    </CheckBox>
                  </CheckBox.Group>
                </div>
              </Col>
            </div>
          </Row>
          <br />
          <p>
            <b>Roundoff</b>
          </p>
          <br />
          <div>
            <Row>
              <Col >
                <Radio.Group
                  defaultValue="1"
                  buttonStyle="solid"
                  onChange={(e) => props.onRoundOffChange(e)}
                >
                  <Radio.Button style={{marginLeft : "10px"}} value="0">Exact</Radio.Button>
                  <Radio.Button style={{marginLeft : "10px"}} value="1">Roundoff to ₹ 1</Radio.Button>
                  <Radio.Button style={{marginLeft : "10px"}} onClick={this.handleClick} value="n">Enter Value</Radio.Button>
                </Radio.Group>
                <InputNumber ref={this.inputRef}
                  id="roundOffInput"
                  style={{marginLeft : "10px"}}
                  disabled={props.disableRoundOffInput}
                />
              </Col>
            </Row>
          </div>
        </div>
      </Modal>
    );
  }
}

export default ReconcileAdvanceModal;
